<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import { scrollIntoView } from "@/UIHelper";
//import { VNumberInput } from "vuetify";
import {
  mountedEditZahl,
  NumberControlProps,
  validateEditZahl,
  textChangedEditZahl,
} from "./EditZahlFunctions";
import { useRegisterValidation } from "@/components/EditorValidator";

const props = defineProps<NumberControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

const { config, ui } = getDefaultEditorControlConfig<
  NumberControlConfig,
  NumberControlProps,
  NumberControlUIData
>(props, emitFn);

ui.number = config.initValue ?? 0.0;
const uiData = reactive(ui);
config.validate = () => validateEditZahl(uiData, config);
useRegisterValidation({ config });

onMounted(() => {
  mounted(uiData, props, config);
  mountedEditZahl(config, props, uiData);
});

function textChanged(txt: any) {
  return textChangedEditZahl(txt, uiData, config);
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-number-input
          v-bind="props"
          :disabled="uiData.disabled"
          :required="uiData.required"
          @focus="scrollIntoView($event)"
          :error-messages="uiData.errorText"
          :min="uiData.min"
          :max="uiData.max"
          v-model="uiData.number"
          @update:modelValue="textChanged"
          :label="uiData.description"
          tile
          variant="outlined"
          density="compact"
          color="warning"
          persistent-hint
          decimal-separator=","
          :step="uiData.step"
          :precision="uiData.decimals"
        ></v-number-input>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>

